import { render, staticRenderFns } from "./IdSearch.vue?vue&type=template&id=11cffd9b&scoped=true&"
import script from "./IdSearch.vue?vue&type=script&lang=js&"
export * from "./IdSearch.vue?vue&type=script&lang=js&"
import style0 from "./IdSearch.vue?vue&type=style&index=0&id=11cffd9b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cffd9b",
  null
  
)

export default component.exports